import React from 'react';
import './Banner.scss';

interface BannerProps {
  children: React.ReactNode;
  color: 'green' | 'yellow' | 'blue' | 'red' | 'orange';
  className?: string;
  size?: 'small' | 'medium';
  style?: React.CSSProperties;
}

const Banner: React.FC<BannerProps> = ({
  children,
  color,
  className = '',
  size = 'medium',
  style
}) => {
  return (
    <div className={`banner banner--${color} banner--${size} ${className}`} style={style}>
      <div className='banner__content'>
        {children}
      </div>
    </div>
  );
};

export default Banner;